import { SvgIcon } from '@mui/material'
// @ts-ignore
import Bill from '../../assets/images/bill.svg?react'
// @ts-ignore
import Cash from '../../assets/images/cash.svg?react'

// @ts-ignore
import Xlsx from '../../assets/images/excel_icon.svg?react'

export function BillIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return <SvgIcon component={Bill} {...props} />
}

export function CashIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return <SvgIcon component={Cash} {...props} />
}

export function XlsxIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return <SvgIcon component={Xlsx} {...props} />
}
